import * as Sentry from '@sentry/react'
import {
  GDPR_FIELDS,
  HEROKU_FIELDS,
  PCI_FIELDS,
  PII_PATTERNS,
  Scrubber
} from '@heroku/js-blanket'
import runtimeConfig from './runtime-config'

export default function initializeSentry() {
  const sentryDSN = runtimeConfig('public_web_sentry_dsn') || ''
  const ENABLE_SENTRY = !!sentryDSN
  if (ENABLE_SENTRY === true) {
    const scrubber = new Scrubber({
      fields: [
        ...GDPR_FIELDS,
        ...HEROKU_FIELDS,
        ...PCI_FIELDS,
        'code',
        'state',
        /csrf/i
      ],
      patterns: [...PII_PATTERNS]
    })

    Sentry.init({
      dsn: sentryDSN,
      environment:
        runtimeConfig('public_web_sentry_client_environment') || 'development',
      integrations: [Sentry.httpClientIntegration()],
      beforeSend: event => {
        return scrubber.scrub(event).data
      }
    })
  } else {
    /* eslint-disable-next-line no-console */
    console.log('🚫 Sentry is disabled')
  }
}
